import { useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { toISODate } from "@/lib/format";
import { printedLabel, terminlisteMeta, terminlisteRows } from "@/components/admin/calendar/terminlisteRows";

const slug = (s) => (s || "terminliste").toLowerCase().replace(/[æ]/g, "ae").replace(/[øö]/g, "o").replace(/[å]/g, "a").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

/** Builds the PDF server-side from the exact rows shown on screen and downloads it; nothing is sent anywhere else. */
export const useTerminlistePdf = () => {
  const [busy, setBusy] = useState(false);
  const save = async ({ entries, scopeLabel, filterLabels, today, roomName }) => {
    setBusy(true);
    try {
      const heading = `Terminliste${scopeLabel ? ` · ${scopeLabel}` : ""}`;
      const payload = { heading, meta: terminlisteMeta({ scopeLabel, filterLabels, count: entries.length }), printed: printedLabel(), rows: terminlisteRows(entries, { today, roomName }).map(({ id, ...r }) => r) };
      const res = await api.post("/admin/calendar/terminliste.pdf", payload, { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = Object.assign(document.createElement("a"), { href: url, download: `terminliste-${slug(scopeLabel)}-${toISODate(new Date())}.pdf` });
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(() => URL.revokeObjectURL(url), 10_000);
      toast.success("PDF-en er lagra til nedlastingar");
    } catch {
      toast.error("Klarte ikkje å lage PDF. Prøv igjen.");
    } finally {
      setBusy(false);
    }
  };
  return { save, busy };
};
